<vl-stats-article
  class="h100 overflow-hidden"
  (close)="dialogRef.close()"
  [articleIdInput]="data?.articleId"
/>
